import React from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText, Divider } from '@mui/material';

const SectorulEconomic: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Sectorul Economic și de Distribuție a Materialelor Ecleziastice
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Departamente și Consilieri
          </Typography>
          <List>
            <ListItem>
              <ListItemText 
                primary="Departamentul Economic și de Materiale Ecleziastice" 
                secondary="Responsabil pentru aspectele economice și materialele ecleziastice"
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText 
                primary="Consilier: Sorina Popa" 
                secondary="Consilier pentru aspectele economice"
              />
            </ListItem>
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SectorulEconomic;
